import React, { useContext, useEffect, useState } from 'react';
import { Card } from 'primereact/card';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Chip } from 'primereact/chip'; // Importar Chip
import { apiService, setupInterceptors } from '../services/apiService';
import { AuthContext } from '../context/AuthContext';
import HeaderComponent from './HeaderComponent';
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import '../styles/RegistroContable.css'

const RegistroContable = ({ toast }) => {
    const { logoutUser } = useContext(AuthContext);
    const [registroContable, setRegistroContable] = useState([]);
    const [totalAcumulado, setTotalAcumulado] = useState(0);
    const [ totalRegistros, setTotalRegistros ] = useState(0);

    // Estados para filtros
    const [fechaDesde, setFechaDesde] = useState(null);
    const [fechaHasta, setFechaHasta] = useState(null);
    const [motivoMovimiento, setMotivoMovimiento] = useState("");

    useEffect(() => {
        setupInterceptors(logoutUser);
        getRegistroContable();
    }, []);

    const getRegistroContable = async () => {
        try {
            // Construir los parámetros de la URL
            let params = new URLSearchParams();

            if (fechaDesde) {
                params.append("fecha_desde", fechaDesde.toISOString().split("T")[0]);
            }
            if (fechaHasta) {
                params.append("fecha_hasta", fechaHasta.toISOString().split("T")[0]);
            }
            if (motivoMovimiento) {
                params.append("motivo_movimiento", motivoMovimiento);
            }

            // Hacer la petición con los filtros
            const response = await apiService.fetchData(`registro_contable/?${params.toString()}`);

            const registroContableList = response.data.registros.map((registro_contable) => ({
                id: registro_contable.id,
                presupuesto: registro_contable.presupuesto,
                compra_producto: registro_contable.compra_producto,
                tipo_movimiento: registro_contable.tipo_movimiento,
                motivo_movimiento: registro_contable.motivo_movimiento,
                ingreso: registro_contable.ingreso,
                egreso: registro_contable.egreso,
                responsable: registro_contable.responsable_usuario,
                created_at: registro_contable.created_at,
                fecha_formateada: registro_contable.fecha_formateada
            }));

            setRegistroContable(registroContableList);
            setTotalAcumulado(response.data.total_acumulado);
            setTotalRegistros(response.data.total_registros);
        } catch (error) {
            console.error("Error al obtener datos:", error.response ? error.response.data : error.message);
        }
    };

    // Formatear el valor en pesos argentinos
    const formatCurrency = (value) => {
        return value.toLocaleString('es-AR', { style: 'currency', currency: 'ARS' });
    };

    // Renderizar Chip verde para Ingreso
    const ingresoTemplate = (rowData) => {
        return rowData.ingreso ? (
            <Chip
                label={formatCurrency(rowData.ingreso)}
                className="p-mr-2"
                style={{ backgroundColor: 'green', color: 'white', fontWeight:500 }}
            />
        ) : '-';
    };

    // Renderizar Chip rojo para Egreso
    const egresoTemplate = (rowData) => {
        return rowData.egreso ? (
            <Chip
                label={formatCurrency(rowData.egreso)}
                className="p-mr-2"
                style={{ backgroundColor: 'red', color: 'white' }}
            />
        ) : '-';
    };

    return (
        <>
            <HeaderComponent title="Registro Contable" />

            {/* Dashboard panel con un total de registros */}
            <div className="p-grid p-align-center p-justify-center dashboard-container mb-4">
                <div className="card-container">
                    <Card className="modern-card total-acumulado-card">
                        <span>Total Acumulado</span>
                        <p className="card-value">{formatCurrency(totalAcumulado)}</p>
                    </Card>

                    <Card className="modern-card-2 total-registros-card">
                        <span>Total Registros</span>
                        <p className="card-value">{totalRegistros}</p>
                    </Card>
                </div>

                {/* Panel de filtros */}
                <div className="p-grid p-justify-center p-mb-3" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '1rem' }}>
                    <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap', justifyContent: 'center' }}>
                        <div className="p-field" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <label className='mb-2 bold'>Fecha Desde</label>
                            <Calendar value={fechaDesde} onChange={(e) => setFechaDesde(e.value)} dateFormat="yy-mm-dd" showIcon />
                        </div>
                        <div className="p-field" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <label className='mb-2 bold'>Fecha Hasta</label>
                            <Calendar value={fechaHasta} onChange={(e) => setFechaHasta(e.value)} dateFormat="yy-mm-dd" showIcon />
                        </div>
                        <div className="p-field" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <label className='mb-2 bold'>Motivo Movimiento</label>
                            <Dropdown 
                                value={motivoMovimiento} 
                                onChange={(e) => setMotivoMovimiento(e.value === "TODOS" ? null : e.value)} 
                                options={["REPOSICION STOCK", "VENTA", "GASTOS", "TODOS"]} 
                                placeholder="Selecciona un motivo"
                                style={{ width: '250px' }} // Ajusta el ancho aquí
                            />
                        </div>
                    </div>
                    <Button label="Filtrar" icon="pi pi-search" onClick={getRegistroContable} />
                </div>


                {/* Tabla de movimientos contables */}
                <div className="p-col-12">
                    <Card title="Detalles de Movimientos">
                        <DataTable value={registroContable} paginator rows={5} responsiveLayout="scroll">
                            <Column field="presupuesto" header="Presupuesto" alignHeader={"center"} style={{ textAlign: "center" }}></Column>
                            <Column field="tipo_movimiento" header="Tipo de Movimiento" alignHeader={"center"} style={{ textAlign: "center" }}></Column>
                            <Column field="motivo_movimiento" header="Motivo" alignHeader={"center"} style={{ textAlign: "center" }}></Column>
                            <Column field="ingreso" header="Ingreso" body={ingresoTemplate} alignHeader={"center"} style={{ textAlign: "center" }} />
                            <Column field="egreso" header="Egreso" body={egresoTemplate} alignHeader={"center"} style={{ textAlign: "center" }} />
                            <Column field="responsable" header="Responsable" alignHeader={"center"} style={{ textAlign: "center" }}></Column>
                            <Column field="fecha_formateada" header="Fecha" alignHeader={"center"} style={{ textAlign: "center" }}></Column>
                        </DataTable>
                    </Card>
                </div>
            </div>
        </>
    );
};

export default RegistroContable;
